import GeneralSelect from 'admin/Selects/GeneralSelect';
import { useIntl } from 'react-intl';
import { StyledContent } from './style';
import { Button } from 'ui';
import { Form, message } from 'antd';
import useQueryApiClient from 'utils/useQueryApiClient';
import { StyledSpinner } from '../../../../ui/Spinner/styles';
import { useState } from 'react';

const TransferUserProfile = () => {
  const [reload, setReload] = useState(0);
  const intl = useIntl();
  const [form] = Form.useForm();

  const transferUser = () => {
    if (form.getFieldsValue().user_to && form.getFieldsValue().user_from) {
      transferUsers(form.getFieldsValue());
    } else {
      message.error(intl.formatMessage({ id: 'admin.not_choosen_farm_user' }));
    }
  };

  const handleSuccess = () => {
    message.success(
      intl.formatMessage({ id: 'admin.succesfuly_transfered_farm' })
    );

    setReload((prev) => prev + 1);
  };

  const { appendData: transferUsers, isLoading: transferingUsers } =
    useQueryApiClient({
      request: {
        url: 'api/v2/transfer-user-farm',
        method: 'POST',
      },
      onSuccess: handleSuccess,
      onError: () =>
        message.error(
          intl.formatMessage({ id: 'admin.failed_to_transfered_farm' })
        ),
    });

  return (
    <StyledContent>
      <StyledSpinner spinning={transferingUsers}>
        <Form form={form}>
          <h4>{intl.formatMessage({ id: 'admin.transfer_description' })}</h4>
          <GeneralSelect
            label={intl.formatMessage({ id: 'admin.transfer_from' })}
            name="user_from"
            reload={reload}
            url="api/v2/transfer-user-farm/farm-user"
          />
          <GeneralSelect
            label={intl.formatMessage({ id: 'admin.transfer_to' })}
            name="user_to"
            reload={reload}
            url="api/v2/transfer-user-farm/to-user"
          />
          <Button
            type="primary"
            label={intl.formatMessage({ id: 'admin.transfer' })}
            loading={transferingUsers}
            onClick={transferUser}
          />
        </Form>
      </StyledSpinner>
    </StyledContent>
  );
};

export default TransferUserProfile;
